import { LandingConfig, LandingSections } from '../../../../../domain/landing-config.interface';

// Funciones puras compartidas por los diseños de landing

// La API trae sections como objeto (una sección) o como lista
export function normalizeSections(config: LandingConfig): LandingSections[] {
  const sections = config?.body?.sections;
  return Array.isArray(sections) ? sections : sections ? [sections] : [];
}

// "CI-SIS-51" -> "51"
export function formCode(number: string): string {
  return number?.match(/(\d+)\s*$/)?.[1] || '';
}

// La API puede traer texto de ejemplo en vez del nombre del icono; solo se pinta un nombre válido
export function isIconName(icon: string): boolean {
  return /^[a-z0-9_]+$/.test(icon || '');
}
